import { ConfigType } from "entities/config";
import { ExtendedInfoType } from "../types";

import { chartsType } from "App";
import Charts from "components/charts";
import { EncounterDetails } from "entities/issues";
import { InfoTypes } from "entities/patientInformation";
import { VitalsChartData } from "hooks/types";
import LabsTile from "./LabsTile";
import { DataTile } from "./Tile";
import VitalsTile from "./VitalsTile";

type TileGroupProps = {
  isCollapsed: boolean;
  groupData: ExtendedInfoType[];
  tests?: ConfigType["tests"];
  vitals?: ConfigType["vitals"];
  type: InfoTypes;
  maxWidth: number;
  groups: string[];
  encounters: Record<string, EncounterDetails[]>;
  view: "year" | "month" | "day";
  labView: "lineChart" | "heatMap";
  onTileClick: (patientInfo?: ExtendedInfoType) => void;
  searchTerm: string;
  vitalsChartData: VitalsChartData;
  chartsToDisplay: string[];
  handleToggleDisplayCharts: (chart: chartsType) => void;
};

const TileGroup = (props: TileGroupProps) => {
  const {
    groupData,
    type,
    vitals,
    tests,
    isCollapsed,
    groups,
    maxWidth,
    encounters,
    view,
    onTileClick,
    searchTerm,
    labView,
    vitalsChartData,
    chartsToDisplay,
    handleToggleDisplayCharts,
  } = props;
  return (
    <div
      className="w-full flex flex-col justify-end items-end bg-white mb-[15px]"
      style={{ minWidth: maxWidth }}
    >
      {isCollapsed ? (
        <div className="">
          <DataTile
            width={maxWidth}
            groups={[]}
            type={type}
            encounters={encounters}
            view={view}
            onTileClick={onTileClick}
            searchTerm={searchTerm}
          />
        </div>
      ) : (
        <div className="flex flex-col justify-between w-full">
          {type == "vitals" ? (
            <div className="w-full">
              {labView == "heatMap" ? (
                <>
                  {vitals?.map((data, i) => (
                    <VitalsTile
                      key={data.name + i}
                      config={data}
                      groups={groups}
                      encounters={encounters}
                      view={view}
                    />
                  ))}
                </>
              ) : (
                <Charts
                  vitalsChartData={vitalsChartData}
                  chartsToDisplay={chartsToDisplay}
                  handleToggleDisplayCharts={handleToggleDisplayCharts}
                />
              )}
            </div>
          ) : type == "tests" ? (
            <div className="w-full">
              {tests?.map((data, i) => (
                <LabsTile
                  key={data.name + i}
                  config={data}
                  groups={groups}
                  encounters={encounters}
                  view={view}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col min-h-14 w-full">
              {groupData.length !== 0 ? (
                <>
                  {groupData?.map((data, i) => (
                    <DataTile
                      key={data.id + data.name + i}
                      data={data}
                      color={data.color}
                      width={maxWidth}
                      groups={groups}
                      encounters={encounters}
                      view={view}
                      onTileClick={onTileClick}
                      searchTerm={searchTerm}
                    />
                  ))}
                </>
              ) : (
                <DataTile
                  width={maxWidth}
                  groups={[]}
                  type={type}
                  encounters={encounters}
                  view={view}
                  onTileClick={onTileClick}
                  searchTerm={searchTerm}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TileGroup;
